import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardInvoicesApiInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-invoices-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string';
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { useControlledSwr } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseAffiliateDashboardInvoicesInterface extends SwrPaginationInterface {
  filter: AffiliateDashboardFilterInterface;
}
export const useAffiliateDashboardInvoices = t0 => {
  const $ = _c(19);
  const {
    filter,
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== filter.dateSince || $[2] !== filter.dateTill) {
    t2 = {
      dateSince: filter.dateSince,
      dateTill: filter.dateTill
    };
    $[1] = filter.dateSince;
    $[2] = filter.dateTill;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const invoicesFilter = t2;
  let t3;
  if ($[4] !== filter.dateSince || $[5] !== filter.vendorId || $[6] !== invoicesFilter || $[7] !== limit || $[8] !== pagination || $[9] !== user) {
    t3 = () => {
      if (!user || filter.dateSince === null) {
        return;
      }
      return [`${AFFILIATE_DASHBOARD_API}/invoices/list${filter.vendorId ? `/${filter.vendorId}` : ""}?${getPaginationAndFilterQueryString({
        limit,
        pagination,
        filter: invoicesFilter
      })}`, RequestModuleEnum.Contacts];
    };
    $[4] = filter.dateSince;
    $[5] = filter.vendorId;
    $[6] = invoicesFilter;
    $[7] = limit;
    $[8] = pagination;
    $[9] = user;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    data: affiliateInvoices
  } = useControlledSwr(t3, fetcher);
  let t4;
  if ($[11] !== filter.dateSince || $[12] !== filter.vendorId || $[13] !== invoicesFilter || $[14] !== user) {
    t4 = () => {
      if (!user || filter.dateSince === null) {
        return;
      }
      return `${AFFILIATE_DASHBOARD_API}/invoices/count${filter.vendorId ? `/${filter.vendorId}` : ""}?${getFilterQueryString({
        filter: invoicesFilter
      })}`;
    };
    $[11] = filter.dateSince;
    $[12] = filter.vendorId;
    $[13] = invoicesFilter;
    $[14] = user;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const {
    data: counter
  } = useSWR(t4, baseFetcher);
  let t5;
  if ($[16] !== affiliateInvoices || $[17] !== counter) {
    t5 = {
      affiliateInvoices,
      counter
    };
    $[16] = affiliateInvoices;
    $[17] = counter;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};